export default "__VITE_ASSET__Dl9R2x9B__"